export default __webpack_public_path__ + "static/media/The Sentinel.41f31c44.png";